import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function HeroTestimonials() {
  const testimonials = [{
    quote: 'Organicé toda mi práctica de postparto en una tarde. Tengo cada sesión pensada y secuenciada para todas mis pacientes. Nunca más el domingo pensando qué hacer el lunes con una mamá en crisis.',
    name: 'Valentina M.',
    role: 'Psicóloga especialista en maternidad',
    location: 'Buenos Aires',
    initial: 'V',
    color: 'bg-terracotta-100 text-terracotta-700'
  }, {
    quote: 'Los guiones de sesión cambiaron todo. Mis pacientes avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar el proceso a mitad de camino.',
    name: 'Florencia R.',
    role: 'Obstétrica en Centro de Salud',
    location: 'Rosario',
    initial: 'F',
    color: 'bg-gold-100 text-gold-700'
  }, {
    quote: 'Adapto la misma herramienta a 3 pacientes con perfiles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con una mamá que no vinculaba bien con su bebé.',
    name: 'Daniela F.',
    role: 'Puericultora y acompañante de postparto',
    location: 'Córdoba',
    initial: 'D',
    color: 'bg-sage-100 text-sage-700'
  }];
  return <section className="py-10 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-124">
      <div className="flex overflow-x-auto pb-6 -mx-4 px-4 md:grid md:grid-cols-3 md:overflow-visible md:pb-0 md:mx-0 md:px-0 gap-4 md:gap-8 snap-x snap-mandatory hide-scrollbar" data-id="element-125">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        delay: i * 0.15
      }} whileHover={{
        y: -5
      }} className="min-w-[85vw] md:min-w-0 snap-center bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-soft border border-navy/5 relative flex flex-col h-full" data-id="element-126">
            <Quote className="w-8 h-8 md:w-10 md:h-10 text-gold/20 absolute top-4 right-4 md:top-6 md:right-6" data-id="element-127" />

            <p className="text-sm md:text-base text-navy/80 italic mb-6 md:mb-8 relative z-10 flex-grow leading-relaxed" data-id="element-128">
              "{t.quote}"
            </p>

            <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-navy/5" data-id="element-129">
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-serif text-lg md:text-xl font-bold ${t.color}`} data-id="element-130">
                {t.initial}
              </div>
              <div data-id="element-131">
                <h4 className="font-bold text-navy text-sm md:text-base" data-id="element-132">
                  {t.name}
                </h4>
                <p className="text-xs md:text-sm text-navy/60" data-id="element-133">{t.role}</p>
                <p className="text-[10px] md:text-xs text-navy/40 mt-0.5 flex items-center gap-1" data-id="element-134">
                  📍 {t.location}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `
    }} data-id="element-135" />
    </section>;
}